export interface InformesModuloConfig {
  pathPrefix: string;
  modulo: string;
  hubPath: string;
  label: string;
  tituloMisInformes: string;
}

export const INFORMES_MODULOS: InformesModuloConfig[] = [
  { pathPrefix: 'ventas', modulo: 'Ventas', hubPath: '/ventas/informes', label: 'Ventas', tituloMisInformes: 'Mis informes de venta' },
  { pathPrefix: 'compras', modulo: 'Compras', hubPath: '/compras/informes', label: 'Compras', tituloMisInformes: 'Mis informes de compra' },
  { pathPrefix: 'inventario', modulo: 'Inventario', hubPath: '/inventario/informes', label: 'Inventario', tituloMisInformes: 'Mis informes de inventario' },
  { pathPrefix: 'tesoreria', modulo: 'Tesoreria', hubPath: '/tesoreria/informes', label: 'Tesorería', tituloMisInformes: 'Mis informes de tesorería' },
  { pathPrefix: 'contabilidad', modulo: 'Contabilidad', hubPath: '/contabilidad/informes', label: 'Contabilidad', tituloMisInformes: 'Mis informes de contabilidad' },
];

export function resolveInformesModuloFromPath(pathname: string): InformesModuloConfig {
  const segment = pathname.split('/').filter(Boolean)[0];
  return INFORMES_MODULOS.find((item) => item.pathPrefix === segment) ?? INFORMES_MODULOS[0];
}
